module.exports = __webpack_public_path__ + "static/assets/c50e0874aba24d4a74297b3ff68cf4e0.png";